/**
 * Materio-themed styles for react-select components.
 * Makes all Select dropdowns look like Bootstrap/Materio form controls.
 */

export const reactSelectStyles = (disabled = false, invalid = false) => ({
  control: (base: any, state: any) => ({
    ...base,
    minHeight: '38px',
    borderRadius: '0.5625rem',
    fontSize: '0.828rem',
    borderColor: invalid ? 'var(--bs-danger)' : state.isFocused ? 'var(--bs-primary)' : 'rgba(var(--bs-border-color-rgb, 75,70,92), 0.3)',
    boxShadow: invalid
      ? (state.isFocused ? '0 0 0 0.2rem rgba(var(--bs-danger-rgb), 0.15)' : 'none')
      : (state.isFocused ? '0 0 0 0.2rem rgba(var(--bs-primary-rgb), 0.15)' : 'none'),
    backgroundColor: disabled ? 'var(--bs-tertiary-bg)' : 'var(--bs-card-bg, var(--bs-body-bg))',
    cursor: disabled ? 'not-allowed' : 'default',
    transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out',
    '&:hover': {
      borderColor: invalid ? 'var(--bs-danger)' : state.isFocused ? 'var(--bs-primary)' : 'rgba(var(--bs-border-color-rgb, 75,70,92), 0.5)',
    },
  }),

  valueContainer: (base: any) => ({
    ...base,
    padding: '0.375rem 0.875rem',
  }),

  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: 'var(--bs-body-color)',
    fontSize: '0.9375rem',
  }),

  singleValue: (base: any) => ({
    ...base,
    color: disabled ? 'var(--bs-secondary-color)' : 'var(--bs-body-color)',
    fontSize: '0.9375rem',
  }),

  placeholder: (base: any) => ({
    ...base,
    color: 'var(--bs-secondary-color)',
    fontSize: '0.9375rem',
  }),

  menu: (base: any) => ({
    ...base,
    backgroundColor: 'var(--bs-body-bg)',
    border: '1px solid rgba(var(--bs-border-color-rgb, 75,70,92), 0.2)',
    boxShadow: '0 0.25rem 1rem rgba(165, 163, 174, 0.45)',
    zIndex: 1060,
    borderRadius: '6px',
    overflow: 'hidden',
  }),

  menuPortal: (base: any) => ({
    ...base,
    zIndex: 200002,
  }),

  option: (base: any, state: any) => ({
    ...base,
    fontSize: '0.9375rem',
    padding: '0.5rem 0.875rem',
    backgroundColor: state.isSelected
      ? 'var(--bs-primary)'
      : state.isFocused
        ? 'rgba(var(--bs-primary-rgb), 0.08)'
        : 'var(--bs-body-bg)',
    color: state.isSelected ? '#fff' : 'var(--bs-body-color)',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: 'var(--bs-primary)',
      color: '#fff',
    },
  }),

  multiValue: (base: any) => ({
    ...base,
    backgroundColor: 'rgba(var(--bs-primary-rgb), 0.12)',
    borderRadius: '4px',
    margin: '2px 4px 2px 0',
  }),

  multiValueLabel: (base: any) => ({
    ...base,
    color: 'var(--bs-primary)',
    fontSize: '0.8125rem',
    fontWeight: 500,
    padding: '1px 6px',
  }),

  multiValueRemove: (base: any) => ({
    ...base,
    color: 'var(--bs-primary)',
    borderRadius: '0 4px 4px 0',
    '&:hover': {
      backgroundColor: 'var(--bs-primary)',
      color: '#fff',
    },
  }),

  indicatorSeparator: (base: any) => ({
    ...base,
    backgroundColor: 'rgba(var(--bs-border-color-rgb, 75,70,92), 0.2)',
  }),

  clearIndicator: (base: any) => ({
    ...base,
    color: 'var(--bs-secondary-color)',
    padding: '0 6px',
    '&:hover': { color: 'var(--bs-body-color)' },
  }),

  dropdownIndicator: (base: any) => ({
    ...base,
    color: 'var(--bs-secondary-color)',
    padding: '0 8px',
    '&:hover': { color: 'var(--bs-body-color)' },
  }),

  noOptionsMessage: (base: any) => ({
    ...base,
    color: 'var(--bs-secondary-color)',
    fontSize: '0.875rem',
  }),

  loadingMessage: (base: any) => ({
    ...base,
    color: 'var(--bs-secondary-color)',
    fontSize: '0.875rem',
  }),
});
